"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseLightModel = void 0;
const sessionlight_model_1 = require("../session/sessionlight.model");
const baseSlug_model_abstract_1 = require("../baseSlug.model.abstract");
class CourseLightModel extends baseSlug_model_abstract_1.BaseSlugModelAbstract {
    constructor(course = null) {
        super("CourseLightModel");
        this.tags = {};
        this.ranking = 0;
        this.sessionLight = {};
        this.idCourse = 0;
        this.category = "";
        this.firstEndDate = null;
        this.firstStartDate = null;
        this.duration = 0;
        this.durationType = "";
        this.previewUrl = "";
        this.previewUrlAlt = "";
        this.price = null;
        this.discountPrice = null;
        this.onSale = false;
        this.location = "";
        this.courseTypeFull = "";
        this.title = "";
        this.slug = "";
        this.idMainSession = -1;
        this.sessionLight = {};
        this.tags = {};
        this.ranking = 0;
        if (course !== null) {
            for (let session of Object.values(course.sessionLight)) {
                this.addSession(session);
            }
        }
    }
    getMainSession() {
        if (this.idMainSession == -1) {
            return null;
        }
        else if (this.sessionLight[this.idMainSession]) {
            return this.sessionLight[this.idMainSession];
        }
        return null;
    }
    getPrice() {
        if (this.idMainSession == -1) {
            return null;
        }
        else if (this.sessionLight[this.idMainSession]) {
            return this.sessionLight[this.idMainSession];
        }
        return null;
    }
    setDataFromSession(session) {
        this.category = session.category;
        this.firstEndDate = session.endDate;
        this.firstStartDate = session.startDate;
        this.duration = session.duration;
        this.durationType = session.durationType;
        this.previewUrl = session.previewUrl;
        this.previewUrlAlt = session.previewUrlAlt;
        this.price = session.price;
        this.discountPrice = session.discountPrice;
        this.onSale = session.onSale;
        this.location = session.location;
        this.courseTypeFull = session.courseTypeFull;
        this.title = session.title;
        this.slug = session.slug;
        this.tags = session.tags;
        this.ranking = session.ranking;
    }
    addSession(session) {
        if (!session || session === null) {
            return false;
        }
        if (this.slug == "" || !this.sessionLight[this.idMainSession] || typeof this.sessionLight[this.idMainSession] === 'undefined' || this.idMainSession == -1) {
            this.setDataFromSession(session);
            this.idMainSession = session.idSession;
            this.sessionLight[session.idSession] = session;
            return true;
        }
        if (session.startDate != null && this.idMainSession != -1 && this.sessionLight[this.idMainSession].startDate) {
            const today = new Date();
            const oldStart = this.sessionLight[this.idMainSession].startDate;
            const newStart = session.startDate;
            if (newStart != null && (newStart.getMilliseconds() < today.getMilliseconds())) {
                return true;
            }
            else {
                this.sessionLight[session.idSession] = session;
                if (!oldStart || (oldStart.getMilliseconds() - today.getMilliseconds() < 0 || newStart.getMilliseconds() - today.getMilliseconds() < oldStart.getMilliseconds() - today.getMilliseconds())) {
                    this.setDataFromSession(session);
                    this.idMainSession = session.idSession;
                }
                else {
                }
            }
            return true;
        }
        else {
            this.sessionLight[session.idSession] = session;
            if (session.idSession > this.idMainSession) {
                this.setDataFromSession(session);
                this.idMainSession = session.idSession;
            }
        }
        return false;
    }
    static fromCourseModel(course) {
        if (course === null || course.getMainSession() === null) {
            return null;
        }
        const courseLight = new CourseLightModel();
        courseLight.addSession(course.getMainSession());
        return courseLight;
    }
    static fromJSON(d) {
        const courseInstance = Object.assign(new CourseLightModel(), typeof d === 'string' ? JSON.parse(d) : d);
        if (courseInstance.sessionLight) {
            const courseSessionCopy = Array.from(Object.values(courseInstance.sessionLight));
            courseInstance.sessionLight = {};
            for (const sessionSerialized of courseSessionCopy) {
                const session = sessionlight_model_1.SessionLightModel.fromJSON(sessionSerialized);
                courseInstance.addSession(session);
            }
        }
        return courseInstance;
    }
}
exports.CourseLightModel = CourseLightModel;
//# sourceMappingURL=courselight.model.js.map